import { render, staticRenderFns } from "./pbi-dealer-networking-balance.page.vue?vue&type=template&id=cf0b5292"
import script from "./pbi-dealer-networking-balance.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dealer-networking-balance.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports